/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Billing_Board_Meta_Plain_OneInputs */



/**
* | output |
* | --- |
* | "1 partner · {amount}" |
*
* @param {Partner_Billing_Board_Meta_Plain_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_plain_one = /** @type {((inputs: Partner_Billing_Board_Meta_Plain_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_Plain_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`1 Partner · ${i?.amount}`)
	return /** @type {LocalizedString} */ (`1 partner · ${i?.amount}`)
});